import { render, staticRenderFns } from "./SysStatus.vue?vue&type=template&id=09d225c7&"
import script from "./SysStatus.vue?vue&type=script&lang=js&"
export * from "./SysStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/monbi/bbx/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09d225c7')) {
      api.createRecord('09d225c7', component.options)
    } else {
      api.reload('09d225c7', component.options)
    }
    module.hot.accept("./SysStatus.vue?vue&type=template&id=09d225c7&", function () {
      api.rerender('09d225c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/SysStatus.vue"
export default component.exports